export enum ActivityItemType {
  DatabaseCreated = 'database.created',
  DatabaseUpdated = 'database.updated',
  DatabaseDeleted = 'database.deleted',

  DocumentCreated = 'document.created',
  DocumentUpdated = 'document.updated',
  DocumentDeleted = 'document.deleted',
  DocumentArchived = 'document.archived',
  DocumentRestored = 'document.restored',
  WhiteboardCreated = 'whiteboard.created',
  WhiteboardUpdated = 'whiteboard.updated',
  WhiteboardDeleted = 'whiteboard.deleted',
  WhiteboardArchived = 'whiteboard.archived',
  WhiteboardRestored = 'whiteboard.restored',
  SkillDeleted = 'skill.deleted',

  WorkspaceCreated = 'workspace.created',
  WorkspaceDeleted = 'workspace.deleted',
  WorkspaceUpdated = 'workspace.updated',

  DatabasePropertyCreated = 'database.property.created',
  DatabasePropertyDeleted = 'database.property.deleted',
  DatabasePropertyUpdated = 'database.property.updated',
  DatabasePropertyPositionUpdated = 'database.property.position.updated',
  DatabasePropertiesPositionUpdated = 'database.properties.position.updated',

  LabelCreated = 'label.created',
  LabelUpdated = 'label.updated',
  LabelDeleted = 'label.deleted',
  StatusCreated = 'status.created',
  StatusUpdated = 'status.updated',
  StatusDeleted = 'status.deleted',

  DatabaseItemCreated = 'database.item.created',
  DatabaseItemDeleted = 'database.item.deleted',
  // DatabaseItemValuesUpdated = 'database.item.updated.values',
  DatabaseItemValueUpdated = 'database.item.updated.value',
  DatabaseItemStateUpdated = 'database.item.updated.state',
  DatabaseItemPositionUpdated = 'database.item.position.updated',
  DatabaseItemCellRevealed = 'database.item.cell.revealed',
  DatabasePropertyHistoryRevealed = 'database.property.history.revealed',

  DatabaseViewCreated = 'database.view.created',
  DatabaseViewDeleted = 'database.view.deleted',
  DatabaseViewUpdated = 'database.view.updated',
  DatabaseViewPositionUpdated = 'database.view.position.updated',

  DatabaseCellFileCreated = 'database.item.file.created',
  DatabaseCellFileUpdated = 'database.item.file.updated',
  DatabaseCellFileDeleted = 'database.item.file.deleted',

  ResourceItemCreated = 'resource.item.created',
  ResourceItemDeleted = 'resource.item.deleted',
  ResourceItemRenamed = 'resource.item.renamed',
  ResourceItemIconUpdated = 'resource.item.icon.updated',
  ResourceItemPositionUpdated = 'resource.item.position.updated',
  ResourceItemPayloadUpdated = 'resource.item.payload.updated',

  ResourceGroupDeleted = 'resource.group.deleted',
  ResourceGroupPositionUpdated = 'resource.group.position.updated',

  GroupMemberCreated = 'group.member.created',
  GroupMemberDeleted = 'group.member.deleted',

  MessageCreated = 'message.created',
  MessageDeleted = 'message.deleted',
  MessageUpdated = 'message.updated',

  ConnectionCreated = 'connection.created',
  ConnectionDeleted = 'connection.deleted',
  ConnectionUpdated = 'connection.updated',

  WorkspaceConversationCreated = 'conversation.created',
  ConversationDeleted = 'conversation.deleted',
  WorkspaceConversationUpdated = 'conversation.updated',

  DashboardItemCreated = 'dashboard.item.created',
  DashboardItemDeleted = 'dashboard.item.deleted',
  DashboardItemUpdated = 'dashboard.item.updated',

  CloudItemCreated = 'cloud.item.created',
  CloudItemDeleted = 'cloud.item.deleted',
  CloudItemUpdated = 'cloud.item.updated',

  DatabaseSliceCreated = 'database.slice.created',
  DatabaseSliceDeleted = 'database.slice.deleted',
  DatabaseSliceUpdated = 'database.slice.updated',
  DatabaseSlicePositionUpdated = 'database.slice.position.updated',

  DatabaseTimeTrackerItemCreated = 'database.time-tracker-item.created',
  DatabaseTimeTrackerItemDeleted = 'database.time-tracker-item.deleted',
  DatabaseTimeTrackerItemUpdated = 'database.time-tracker-item.updated',

  CloudItemCompletedFileVariantCreated = 'cloud.item.completed-file-variant.created',
  DatabaseCellFileCompletedFileVariantCreated = 'database.item.file.completed-file-variant.created',
  MessageCompletedFileVariantCreated = 'message.completed-file-variant.created',

  DashboardDeleted = 'dashboard.deleted',

  CallRoomDeleted = 'call.room.deleted',
  CallRoomUpdated = 'call.room.updated',

  FolderDeleted = 'folder.deleted',

  WebhookListenerDeleted = 'webhook.listener.deleted',
  WebhookListenerUpdated = 'webhook.listener.updated',
  WebhookListenerCreated = 'webhook.listener.created',

  AutomationCreated = 'automation.created',
  AutomationDeleted = 'automation.deleted',
  AutomationUpdated = 'automation.updated',

  AppUpdated = 'app.updated',

  ConnectionDefinitionCreated = 'app.connection-definition.created',
  ConnectionDefinitionDeleted = 'app.connection-definition.deleted',

  WebhookListenerDefinitionCreated = 'app.webhook-listener-definition.created',
  WebhookListenerDefinitionDeleted = 'app.webhook-listener-definition.deleted',

  DynamicFieldDefinitionCreated = 'app.dynamic-field-definition.created',
  DynamicFieldDefinitionDeleted = 'app.dynamic-field-definition.deleted',

  AutomationAppItemCreated = 'app.item.created',
  AutomationAppItemDeleted = 'app.item.deleted',
  AutomationAppItemUpdated = 'app.item.updated',

  AutomationVersionCreated = 'automation.version.created',
  AutomationVersionUpdated = 'automation.version.updated',

  CallParticipantCreated = 'call.participant.created',
  CallParticipantUpdated = 'call.participant.updated',
  AutomationRunCreated = 'automation.run.created',
  AutomationRunUpdated = 'automation.run.updated',

  ResourceWatcherCreated = 'resource.watcher.created',
  ResourceWatcherDeleted = 'resource.watcher.deleted',

  WorkspaceAppAccessRequestCreated = 'workspace.app-access-request.created',
  WorkspaceAppAccessRequestUpdated = 'workspace.app-access-request.updated',
  WorkspaceAppAccessRequestDeleted = 'workspace.app-access-request.deleted',

  AgentCreated = 'agent.created',
  AgentUpdated = 'agent.updated',
  AgentDeleted = 'agent.deleted',
  AgentArchived = 'agent.archived',
  AgentRestored = 'agent.restored',
  AgentRunCreated = 'agent.run.created',
  AgentRunUpdated = 'agent.run.updated',
}
